import { motion } from "framer-motion";
import MovingBackground from "./MovingBackground";
import jesperImg from "@/assets/jesper-west.jpg";

const ease = [0.16, 1, 0.3, 1] as const;

const MediaSlide = ({ thumbnail }: { thumbnail?: boolean }) => (
  <div className="relative w-full h-full flex items-center bg-background overflow-hidden">
    <MovingBackground variant="waves" />

    <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 md:gap-16 px-8 md:px-20 w-full">
      {/* Image side */}
      <motion.div
        className="flex-shrink-0"
        initial={thumbnail ? false : { opacity: 0, x: -60, scale: 0.9 }}
        animate={{ opacity: 1, x: 0, scale: 1 }}
        transition={{ duration: 0.8, ease }}
      >
        <div className="relative">
          <div
            className="absolute -inset-2 rounded-2xl opacity-30"
            style={{ background: "var(--gradient-primary)" }}
          />
          <img
            src={jesperImg}
            alt="Jesper West"
            className="relative rounded-2xl object-cover shadow-2xl"
            style={{
              width: thumbnail ? "80px" : "clamp(200px, 25vw, 400px)",
              height: thumbnail ? "100px" : "clamp(250px, 30vw, 500px)",
            }}
          />
          {/* Floating badge */}
          {!thumbnail && (
            <motion.div
              className="absolute -bottom-4 -right-4 glass rounded-xl px-4 py-2 border border-primary/20"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.6, duration: 0.5, ease }}
            >
              <p className="font-display text-sm font-semibold text-primary">15+ Years</p>
              <p className="text-xs text-muted-foreground">IT Advisory</p>
            </motion.div>
          )}
        </div>
      </motion.div>

      {/* Text side */}
      <motion.div
        className="flex-1 max-w-xl"
        initial={thumbnail ? false : { opacity: 0, x: 40 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3, duration: 0.7, ease }}
      >
        <p className="label-text mb-3" style={{ fontSize: thumbnail ? "0.5rem" : undefined }}>
          Meet the Advisor
        </p>
        <h2
          className="font-display font-bold text-foreground mb-4"
          style={{ fontSize: thumbnail ? "0.9rem" : "clamp(1.5rem, 3vw, 3rem)" }}
        >
          Jesper West
        </h2>
        <p
          className="text-muted-foreground font-body leading-relaxed mb-6"
          style={{ fontSize: thumbnail ? "0.45rem" : "clamp(0.85rem, 1.2vw, 1.1rem)" }}
        >
          Independent IT consultant specializing in Microsoft 365 Copilot deployment, AI governance frameworks, and enterprise security architecture.
        </p>

        {!thumbnail && (
          <div className="flex flex-wrap gap-2">
            {["Microsoft 365", "Copilot", "AI Governance", "Security"].map((tag, i) => (
              <motion.span
                key={tag}
                className="px-3 py-1 rounded-full text-xs font-medium border border-primary/30 text-primary bg-primary/5"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 + i * 0.1, duration: 0.4, ease }}
              >
                {tag}
              </motion.span>
            ))}
          </div>
        )}
      </motion.div>
    </div>
  </div>
);

export default MediaSlide;
